import type { TrackingConsentLocale } from './types';

const locale: TrackingConsentLocale = {
  copy: {
    title: 'Używamy plików cookie',
    description:
      'Używamy plików cookie i podobnych technologii, aby zapewnić to doświadczenie. Niezbędne pliki cookie są zawsze aktywne.',
    allow_label: 'Zaakceptuj wszystkie pliki cookie',
    reject_label: 'Tylko niezbędne',
    settings_label: 'Ustawienia plików cookie',
    policy_link_label: 'Polityka prywatności i plików cookie',
    categories_label: 'Kategorie',
    always_on_label: 'Zawsze aktywne',
    required_label: 'Wymagane',
    save_preferences_label: 'Zapisz preferencje',
    close_label: 'Zamknij',
    allow_all_optional_categories_label: 'Zezwól na wszystkie opcjonalne kategorie',
    settings_title: 'Ustawienia plików cookie',
    settings_description:
      'Używamy plików cookie i podobnych technologii, aby zapewnić to doświadczenie. Niezbędne pliki cookie są zawsze aktywne.',
    save_error: 'Nie udało się zapisać Twojego wyboru prywatności. Spróbuj ponownie.'
  },
  categories: {
    strictly_necessary: {
      name: 'Niezbędne',
      purpose: 'Są niezbędne do zapewnienia tego doświadczenia i nie można ich wyłączyć.'
    },
    analytics: {
      name: 'Analityka',
      purpose: 'Mierzy, jak odwiedzający korzystają z tego doświadczenia, aby poprawić wydajność.'
    },
    marketing: { name: 'Marketing', purpose: 'Wspiera reklamy i marketing wybrane przez organizatora.' }
  }
};

export default locale;
